import httpService from './http.service';

function index() {
  return httpService.get('/tags');
}

export default {
  index
};
